import type { Resolver } from 'cpool-schemas';
import { divisionId, divisionName, schemaId } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    // positions are per table: template writes vs. division (de)activations
    divisionPosition?: number;
    position?: number;
};

const schemaDivisionHeaderFooterPart = z.object({
    active: z.boolean(),
    mailContent: z.string(),
    mailHTMLContent: z.string(),
    templateId: schemaId,
});

export const schemaTemplateResolver_ListDivisionHeaderFooters = z.array(
    z.object({
        divisionAggregateId: schemaId,
        divisionId,
        footer: schemaDivisionHeaderFooterPart.nullable(),
        header: schemaDivisionHeaderFooterPart.nullable(),
        name: divisionName,
    }),
);

export type DivisionHeaderFooterPart = z.infer<typeof schemaDivisionHeaderFooterPart>;

export type SchemaTemplateResolver_ListDivisionHeaderFooters = z.infer<
    typeof schemaTemplateResolver_ListDivisionHeaderFooters
>;

export type TemplateResolver_ListDivisionHeaderFooters = Resolver<
    Arguments,
    SchemaTemplateResolver_ListDivisionHeaderFooters
>;
